import { render, staticRenderFns } from "./NotVeryGoodExperience.vue?vue&type=template&id=454e35eb&"
import script from "./NotVeryGoodExperience.vue?vue&type=script&lang=js&"
export * from "./NotVeryGoodExperience.vue?vue&type=script&lang=js&"
import style0 from "./NotVeryGoodExperience.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports